export default class FinesseSearchButton extends HTMLElement {
  active: boolean = false
  button: HTMLElement | null = null

  static get observedAttributes() {
    return ['active']
  }

  constructor() {
    super()

    this.button = this.querySelector<HTMLElement>('button[data-search-button]') as HTMLElement

    (window as any).addEventListener('search:toggle', this.handleSearch.bind(this))
    this.button.addEventListener('click', this.handleClick.bind(this))
  }
  
  get isActive() {
    return this.active
  }

  set isActive(value: boolean) {
    this.active = value
    this.setAttribute('active', value.toString())
    // this.toggle()
  }

  handleSearch(evt: CustomEvent) {
    // @ts-ignore
    this.isActive = evt.detail.active
  }

  handleClick(evt: Event) {
    evt.preventDefault()

    window.dispatchEvent(new CustomEvent('search:toggle', { bubbles: true, detail: { active: !this.isActive } }))
  }
}

customElements.define('finesse-search-button', FinesseSearchButton)

